// extracted by mini-css-extract-plugin
export default {"registration":"itemRegistration_registration__pUQtc","registration_heading":"itemRegistration_registration_heading__TLkuG","add_btn":"itemRegistration_add_btn__pHMUd"};